/** Why the annotation tools are off for somebody who can see the slide: the server's own words. */
export const READ_ONLY_REASON = 'You can view this slide but not annotate it';

export interface AnnotationAccess {
  /** A tool can be armed, by its button or its shortcut. */
  draw: boolean;
  /** The person's own annotations can be renamed, reshaped or deleted; nobody else's ever can. */
  edit: boolean;
  /** Shown on the tool buttons when they are there but off. Absent when the
   *  tools are usable, or not offered at all (a flat image, a compare stack). */
  disabledReason?: string;
}

/**
 * What the study page lets the person do with annotations.
 *
 * `readOnly` is undefined until the page knows (the enterprise page asks the
 * study head): nothing is editable meanwhile, and the tools stay hidden rather
 * than flashing "you cannot" at somebody who can. Annotations are displayed in
 * every case; only changing them is gated.
 */
export function annotationAccess({ supported, readOnly }: { supported: boolean; readOnly: boolean | undefined }): AnnotationAccess {
  const edit = readOnly === false;
  return {
    draw: supported && edit,
    edit,
    disabledReason: supported && readOnly === true ? READ_ONLY_REASON : undefined,
  };
}
